export const _0px = 0 as 0 & Pixels;
export const _1px = 1 as 1 & Pixels;
